import React from "react";
import logo from "../../assets/images/lock-icon.svg";

const lockLogo = props => (
  <img className={props.className} src={logo} alt="lock" />
);

export default lockLogo;
